import { useState } from "react";
const initialState = {
    nombre: "",
    empresa: "",
    telefono: "",
    correo: "",
    mensaje: ""
}

export default function useFormValue() {
    const [values, setValues] = useState(initialState)

    const handleStateForm = ({ target }) => {
        setValues({
            ...values,
            [target.name]: target.value
        })

    }
    return {
        values, handleStateForm
    }

}
